export default __webpack_public_path__ + "static/media/25082601.b79b604d.jpg";